import { lookupTerm } from './glossary';

let tooltipEl: HTMLDivElement | null = null;

export function initTooltip(): void {
  if (!tooltipEl) {
    tooltipEl = document.createElement('div');
    tooltipEl.className = 'tooltip';
    tooltipEl.hidden = true;
    document.body.appendChild(tooltipEl);
  }

  document.addEventListener('click', (e) => {
    const link = (e.target as HTMLElement).closest('.glossary-link') as HTMLElement | null;
    if (link) {
      e.preventDefault();
      const term = link.dataset.term || link.textContent || '';
      const entry = lookupTerm(term);
      if (entry && tooltipEl) {
        tooltipEl.innerHTML = `<span class="tooltip-term">${entry.term}</span><span class="tooltip-def">${entry.definition}</span>`;
        tooltipEl.hidden = false;
        const rect = link.getBoundingClientRect();
        tooltipEl.style.left = `${Math.min(rect.left, window.innerWidth - 320)}px`;
        tooltipEl.style.top = `${rect.bottom + 8}px`;
      }
    } else {
      if (tooltipEl) tooltipEl.hidden = true;
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && tooltipEl) tooltipEl.hidden = true;
  });
}

export function glossarySpan(term: string, display?: string): string {
  return `<span class="glossary-link" data-term="${term}">${display || term}</span>`;
}
